import React from "react";

export default function AIDisclaimerFooter(): React.JSX.Element {
    return (
        <div
            className="mt-6 pt-4 text-center"
            style={{ borderTop: '1px solid var(--rule)', color: 'var(--ink-muted)', fontSize: 'var(--fs-label)' }}
        >
            <p>
                AI-powered analysis • Not medical advice •{' '}
                <a
                    href="/ai-disclaimer"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline underline-offset-2"
                    style={{ color: 'var(--c-kivo-teal)' }}
                >
                    Learn more
                </a>
                {' '}•{' '}
                <a
                    href="/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline underline-offset-2"
                    style={{ color: 'var(--c-kivo-teal)' }}
                >
                    Privacy
                </a>
                {' '}•{' '}
                <a
                    href="/refund"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline underline-offset-2"
                    style={{ color: 'var(--c-kivo-teal)' }}
                >
                    Refund
                </a>
            </p>
        </div>
    );
}
